import { Link } from "@tanstack/react-router";
import { TerminalIcon } from "lucide-react";

import { Button } from "../ui/button";

/**
 * Codex and Claude run through a local T3 companion, not the hosted Worker.
 * When no environment is linked, this explains the one process the owner needs
 * to start and where to connect it, instead of leaving the provider list empty.
 */
export function HostedLocalCompanionCard() {
  return (
    <section
      aria-labelledby="hosted-companion-heading"
      className="rounded-xl border border-border/70 bg-card/25 p-4"
      data-testid="hosted-companion-card"
    >
      <div className="flex items-start gap-3">
        <span className="mt-0.5 grid size-7 shrink-0 place-items-center rounded-lg border border-border/70 bg-background/70 text-muted-foreground">
          <TerminalIcon className="size-3.5" />
        </span>
        <div className="min-w-0">
          <h2 className="text-sm font-medium text-foreground" id="hosted-companion-heading">
            Codex and Claude need a local companion
          </h2>
          <p className="mt-1 text-xs leading-relaxed text-muted-foreground/80">
            CLI providers run on your machine and keep filesystem access there. Start the companion
            with <code className="font-mono text-foreground/90">npx t3</code>, then connect it here
            to use Codex or Claude Code in this project.
          </p>
          <div className="mt-3">
            <Button render={<Link to="/settings/connections" />} size="xs" variant="outline">
              Open Connections
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
